import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { LanguageService } from './../services/language.service';

@Injectable({
  providedIn: 'root',
})
export class SharedSessionGuard  {
  constructor(private languageService: LanguageService, private router: Router) {}
  public canActivate(
    next: ActivatedRouteSnapshot,
  ): Observable<boolean> | Promise<boolean> | boolean {
    this.router.navigate([this.languageService.getDefaultLanguage() + '/session/'], {
      queryParams: next.queryParams,
    });
    return true;
  }
}
